// Generated by CoffeeScript 2.3.2

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { Component } from 'react';
;
var LogDialog, cardList, cardPhrase, playerList, suggestedCardsClause, transcribedList;

cardPhrase = function(card, configuration, usePreposition = true) {
  var phrase, type;
  type = configuration.types[card.type];
  phrase = "";
  if (usePreposition) {
    phrase += type.preposition;
  }
  phrase += type.article;
  phrase += card.name;
  return phrase;
};

transcribedList = function(list) {
  var i, j, len, ref, string;
  string = list[0];
  if (list.length > 1) {
    if (list.length > 2) {
      ref = list.slice(1, -1);
      for (j = 0, len = ref.length; j < len; j++) {
        i = ref[j];
        string += ", " + i;
      }
      string += ", and " + list[list.length - 1];
    } else {
      string += " and " + list[1];
    }
  }
  return string;
};

playerList = function(playerIds) {
  if (playerIds.length > 0) {
    return transcribedList(playerIds);
  } else {
    return "Nobody";
  }
};

cardList = function(cardIds, configuration) {
  var cards, id, names;
  cards = configuration.cards;
  names = (function() {
    var j, len, results;
    results = [];
    for (j = 0, len = cardIds.length; j < len; j++) {
      id = cardIds[j];
      results.push(cardPhrase(cards[id], configuration, false));
    }
    return results;
  })();
  return transcribedList(names);
};

suggestedCardsClause = function(cardIds, configuration) {
  var card1, card2, card3, cards, clause, id, suggestionOrder;
  cards = configuration.cards;
  suggestionOrder = configuration.suggestionOrder;
  card1 = ((function() {
    var j, len, results;
    results = [];
    for (j = 0, len = cardIds.length; j < len; j++) {
      id = cardIds[j];
      if (cards[id].type === suggestionOrder[0]) {
        results.push(cards[id]);
      }
    }
    return results;
  })())[0];
  card2 = ((function() {
    var j, len, results;
    results = [];
    for (j = 0, len = cardIds.length; j < len; j++) {
      id = cardIds[j];
      if (cards[id].type === suggestionOrder[1]) {
        results.push(cards[id]);
      }
    }
    return results;
  })())[0];
  card3 = ((function() {
    var j, len, results;
    results = [];
    for (j = 0, len = cardIds.length; j < len; j++) {
      id = cardIds[j];
      if (cards[id].type === suggestionOrder[2]) {
        results.push(cards[id]);
      }
    }
    return results;
  })())[0];
  clause = cardPhrase(card1, configuration) + " ";
  clause += cardPhrase(card2, configuration) + " ";
  clause += cardPhrase(card3, configuration);
  return clause;
};

LogDialog = class LogDialog extends Component {
  constructor(props) {
    super(props);
    this.configuration = null;
    return;
  }

  describeSetup(info) {
    return `Playing ${this.configuration.name} with ${playerList(info.players)}.`;
  }

  describeHand(info) {
    return `${info.player} has ${cardList(info.cards, this.configuration)}.`;
  }

  describeSuggest(info) {
    if (this.configuration.rules === "master") {
      return this.describeSuggestMaster(info);
    } else {
      return this.describeSuggestClassic(info);
    }
  }

  describeSuggestMaster(info) {
    return `${info.suggester} suggested: ${suggestedCardsClause(info.cards, this.configuration)}. ${playerList(info.showed)} showed a card.`;
  }

  describeSuggestClassic(info) {
    var description;
    description = `${info.suggester} suggested ${suggestedCardsClause(info.cards, this.configuration)}.`;
    if (info.showed.length > 0) {
      if (info.showed.length > 1) {
        description += ` ${playerList(info.showed.slice(0, -1))} did not show a card.`;
      }
      description += ` ${info.showed[info.showed.length - 1]} showed a card.`;
    } else {
      description += " Nobody showed a card.";
    }
    return description;
  }

  describeShow(info) {
    var cards;
    cards = this.configuration.cards;
    return `${info.player} showed ${cardPhrase(cards[info.card], this.configuration, false)}.`;
  }

  describeAccuse(info) {
    return `${info.accuser} made an accusation: ${suggestedCardsClause(info.cards, this.configuration)}. The accusation was ${(info.outcome ? "" : "not ")}correct.`;
  }

  describeCommlink(info) {
    return `${info.caller} asked ${info.receiver} about ${suggestedCardsClause(info.cards, this.configuration)}. ${info.subject} ${(info.showed ? "showed" : "did not show")} a card.`;
  }

  describeEntry(entry) {
    if (entry.setup != null) {
      return this.describeSetup(entry.setup);
    } else if (entry.hand != null) {
      return this.describeHand(entry.hand);
    } else if (entry.suggest != null) {
      return this.describeSuggest(entry.suggest);
    } else if (entry.show != null) {
      return this.describeShow(entry.show);
    } else if (entry.accuse != null) {
      return this.describeAccuse(entry.accuse);
    } else if (entry.commlink != null) {
      return this.describeCommlink(entry.commlink);
    } else {
      return alert("Unknown log entry");
    }
  }

  render() {
    var configurations, entry, log, onClose, open, step;
    ({open, log, configurations, onClose} = this.props);
    this.configuration = (log[0] != null) && (log[0].setup != null) ? configurations[log[0].setup.variation] : null;
    return <Dialog open={open} fullscreen="true" disableBackdropClick={true} onClose={onClose}>
      <DialogTitle id="form-dialog-title">Log</DialogTitle>
      <DialogContent>
        <ol>
          {(function() {
      var j, len, results;
      results = [];
      for (step = j = 0, len = log.length; j < len; step = ++j) {
        entry = log[step];
        results.push(<li key={step}> {this.describeEntry(entry)} </li>);
      }
      return results;
    }).call(this)}
        </ol>
     </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={onClose}> Done </Button>
      </DialogActions>
    </Dialog>;
  }

};

export default LogDialog;
